import LanguagesModel from '../Apis/Languages'
import Controller from './Controller'

export default class LanguagesController extends Controller {
  constructor() {
    super(new LanguagesModel())
  }
  async GetActivelanguages() {
    const response = this.model.GetActivelanguages();
    return response
 }
}
